export type PlanId = 'premium' | 'base';

// Para cambiar el producto, reemplazá el ID numérico en cada link de checkout.
export const plans = [
  {
    id: 'premium' as PlanId,
    name: 'Megapack Premium',
    detail: '6 tomos + 3 extras + 2 tomos premium',
    extra: 'Incluye Cine de Terror Argentino + Historias Para Leer a Oscuras',
    oldPrice: '$39.990',
    price: '$19.999',
    savings: 'AHORRÁS $15.000',
    featured: true,
    cta: 'SÍ, QUIERO MI MEGAPACK PREMIUM',
    checkoutUrl: 'https://checkout.practicandsimple.shop/cart/67651932586353:1',
  },
  {
    id: 'base' as PlanId,
    name: 'Megapack Base',
    detail: '6 tomos + 3 extras',
    extra: '',
    oldPrice: '$29.990',
    price: '$14.999',
    savings: '',
    featured: false,
    cta: 'QUIERO MI MEGAPACK BASE',
    checkoutUrl: 'https://checkout.practicandsimple.shop/cart/67651932324209:1',
  },
];
